import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LicenceActions, {
   getLicenceData,isFetchingLicence
} from 'pgdb-data-layer/lib/Redux/LicenceRedux';
import EndorsementActions, {
   getEndorsement,
   isFetchingEndorsement,
} from 'pgdb-data-layer/lib/Redux/EndorsementRedux';
import { getToken } from '../../../Session/SessionRedux';
import DashboardCard from '../index';
import * as REGISTRATION from 'pgdb-data-layer/lib/Constants/Registration';

const EndorsementCard = ({ token, userLicence, isLoadingLicence, getLicences, isLoadingEndorsements, endorsements, getEndorsements }) => {

   const [isEligibleEndorsement,setIsEligibleEndorsement] = useState(false);

   useEffect(() => {
      if (token && (!userLicence.currentLicences || userLicence.currentLicences.length === 0)) {
         getLicences(token);
      }
   }, [token, getLicences]);

   useEffect(() => {
      if (token && (!endorsements.endorsements || endorsements.endorsements.length === 0)) {
         getEndorsements(token);
      }
   }, [token, getEndorsements]);

   useEffect(() => {
      if (userLicence && userLicence.currentLicences) {
         // Check if user has any active certificate licence
         const activeCertificate = userLicence.currentLicences.find(
            licence =>
               licence.status === 'Active' &&
               (licence.typeCode === REGISTRATION.CERTIFYING_PLUMBER_CODE || // Certifying Plumber
                  licence.typeCode === REGISTRATION.CERTIFYING_DRAINLAYER_CODE) // Certifying Drainlayer
         );
         setIsEligibleEndorsement(!!activeCertificate);
      }
   }, [userLicence]);

   const hasEndorsements = endorsements.endorsements && endorsements.endorsements.length > 0;

   return (!isLoadingLicence && isEligibleEndorsement ?
      <DashboardCard
         header="SELF-CERTIFICATION ENDORSEMENT"
         icon="person_raised_hand"
         iconStyle="grey2-text"
         description={hasEndorsements ? 'Manage your endorsement' : 'Not yet endorsed'}
         visible={!isLoadingEndorsements && !isLoadingLicence && isEligibleEndorsement}
         disabled={false}
         navLink={{
            href: 'endorsements',
            text: hasEndorsements ? 'Apply, View or Renew' : 'Apply',
         }}
      />
   : null);
};

EndorsementCard.propTypes = {
   token: PropTypes.string.isRequired,
   userLicence:  PropTypes.object.isRequired,
   isLoadingLicence: PropTypes.bool.isRequired,
   getLicences: PropTypes.func.isRequired,
   isLoadingEndorsements: PropTypes.bool.isRequired,
   endorsements: PropTypes.object.isRequired,
   getEndorsements: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
   return {
      token: getToken(state),
      userLicence: getLicenceData(state),
      isLoadingLicence: isFetchingLicence(state),
      isLoadingEndorsements: isFetchingEndorsement('getUserEndorsement', state),
      endorsements: getEndorsement(state).endorsement,
   };
};

const mapDispatchToProps = dispatch => ({
   getLicences: token => dispatch(LicenceActions.licenceRequest(token)),
   getEndorsements: token => dispatch(EndorsementActions.getUserEndorsementRequest(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EndorsementCard);
